import React from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom';
import viewsTV from './views/tv';
import viewsHomepage from './views/homepage';
import viewsInformation from './views/information';
import viewsMedia from './views/media';
import viewsNews from './views/news';
import viewsContact from './views/contact';
import viewsIasi from './views/iasi';
import viewsLogin from './views/login';
import viewIntranet from './views/intranet';
import viewsInfoPublic from './views/infopublic';
import viewsInfoPublicTransparentaDecizionala from './views/infopublictransparentadecizionala';
import viewsInfoPublicCariere from './views/infopubliccariere';
import viewsInfoPublicAvere from './views/infopublicavere';
import viewsInfoPublicInfoAeroport from './views/infopublicinfoaeroport';
import viewsInfoPublicLegislatie from './views/infopubliclegislatie';
import viewsSearch from './views/search';
import viewsBy from './views/by';
import websiteSettingsService from './services/websiteSettings';
import './global.css';

const Components = {
  'viewsHomepage': viewsHomepage,
  'viewsTV': viewsTV,
  'viewsInformation': viewsInformation,
  'viewsMedia': viewsMedia,
  'viewsNews': viewsNews,
  'viewsContact': viewsContact,
  'viewsIasi': viewsIasi,
  'viewIntranet': viewIntranet,
  'viewsLogin': viewsLogin,
  'viewsInfoPublic': viewsInfoPublic,
  'viewsInfoPublicTransparentaDecizionala': viewsInfoPublicTransparentaDecizionala,
  'viewsInfoPublicCariere': viewsInfoPublicCariere,
  'viewsInfoPublicAvere': viewsInfoPublicAvere,
  'viewsInfoPublicInfoAeroport': viewsInfoPublicInfoAeroport,
  'viewsInfoPublicLegislatie': viewsInfoPublicLegislatie,
  'viewsSearch': viewsSearch,
  'viewsBy': viewsBy
};

const fetch = () => {
  return websiteSettingsService.data().then(websiteSettings => {
    const global = Object.assign({}, websiteSettings.global, { pages: websiteSettings.pages });

    const routesFromSettings = websiteSettings.pages
    .filter(page => page.path)
    .map((page, index) => {
      let component = null;
      let routeProps = null;

      if (page.component === 'viewsIntranet') {
        component = viewIntranet;
        window._props = Object.assign({}, {
          global: global
        }, page);
      }
      else if (page.component === 'viewsLogin') {
        component = viewsLogin;
        window._props = Object.assign({}, {
          global: global
        }, page);
      }
      else {
        component = Components[page.component].bind(this, Object.assign({}, { global: global }, page));
      }

      const props = {
        path: page.path,
        exact: true,
        component: component,
        key: `${page.path}-${index}`,
        websiteSettings: page,
        props: routeProps
      };

      return <Route {...props} />;
    });

    const routes = (
      <Router>
        <Switch>
          {routesFromSettings}
        </Switch>
      </Router>
    );

    ReactDOM.render(
      routes,
      document.getElementById('root')
    );
  })
  .catch(error => {
    console.log(error);
    setTimeout(fetch, 2000);
  });
};

fetch();



// WEBPACK FOOTER //
// ./src/index.js